import 'slick-carousel';
import $ from 'jquery';

const BannerSlider = () => {
    $('.banner-slider__slider').slick({
        slidesToShow: 1,
        dots: true,
        arrows: false,
        draggable: false,
        fade: true,
        appendDots: $('.banner-slider-nav__dots')
    })

    $('.banner-slider-nav__left').click(() => {
        $('.banner-slider__slider').slick('prev');
    });

    $('.banner-slider-nav__right').click(() => {
        $('.banner-slider__slider').slick('next');
    })
}

export default BannerSlider;


// WEBPACK FOOTER //
// ./src/js/app/components/BannerSlider.js